import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractApproval } from './abstract-approval';

@inheritSerialization(AbstractApproval)
export class ProviderFeeSchedule extends AbstractApproval {
  @autoserialize
  transitProgramId: number;

  @autoserialize
  providerId: number;

  @autoserialize
  serviceLevelId: number;

  @autoserialize
  fareCalculatorId: number;

  @autoserialize
  minimumFare: number;

  @autoserialize
  baseFare: number;

  @autoserialize
  distanceRate: number;

  @autoserialize
  timeRate: number;

  @autoserialize
  loadFee: number;

  @autoserialize
  loadFeeBaseDistance: number;

  @autoserialize
  mileageRate: number;

  @autoserialize
  fuelSurchargeRate: number;

  @autoserialize
  cancellationFee: number;

  @autoserialize
  cancellationCredit: number;

  @autoserialize
  noShowCredit: number;
}
